import { getCurrentInstance, inject } from 'vue'
import { appFrontendLogger } from './FrontendLogger'

export const FRONTEND_STORAGE_KEY = Symbol('frontend-storage')

export class FrontendStorage {
  isAvailable() {
    return false
  }

  getItem() {
    return null
  }

  setItem() {}

  removeItem() {}
}

export class BrowserFrontendStorage extends FrontendStorage {
  constructor({
    storageAccessor = () => (typeof window !== 'undefined' ? window.localStorage : undefined),
    logger = appFrontendLogger.child('[FrontendStorage]'),
  } = {}) {
    super()
    this.storageAccessor = storageAccessor
    this.logger = logger
  }

  getStorage() {
    try {
      return this.storageAccessor?.() ?? null
    } catch (error) {
      this.logger.warn('Failed to access browser storage', error)
      return null
    }
  }

  isAvailable() {
    const storage = this.getStorage()
    if (!storage) return false
    try {
      const key = '__frontend_storage_test__'
      storage.setItem(key, key)
      storage.removeItem(key)
      return true
    } catch {
      return false
    }
  }

  getItem(key) {
    const storage = this.getStorage()
    if (!storage) return null
    try {
      return storage.getItem(key)
    } catch (error) {
      this.logger.warn(`Failed to read storage key: ${key}`, error)
      return null
    }
  }

  setItem(key, value) {
    const storage = this.getStorage()
    if (!storage) return
    try {
      storage.setItem(key, value)
    } catch (error) {
      this.logger.warn(`Failed to write storage key: ${key}`, error)
    }
  }

  removeItem(key) {
    const storage = this.getStorage()
    if (!storage) return
    try {
      storage.removeItem(key)
    } catch (error) {
      this.logger.warn(`Failed to remove storage key: ${key}`, error)
    }
  }
}

export const appFrontendStorage = new BrowserFrontendStorage()

export function useFrontendStorage() {
  if (!getCurrentInstance()) {
    return appFrontendStorage
  }
  return inject(FRONTEND_STORAGE_KEY, appFrontendStorage)
}
